export default {
  Input: {
    parts: ['field', 'addon', 'element'],
    baseStyle: {},
    sizes: {
      md: {
        field: {
          padding: 4,
          borderRadius: 'base',
          h: 12,
          fontSize: 'md',
          lineHeight: 'md',
        },
        addon: {
          py: 4,
          px: 0,
          borderRadius: 'base',
          h: 12,
          fontSize: 'md',
          lineHeight: 'md',
        },
      },
      sm: {
        field: {
          padding: 3,
          borderRadius: 'base',
        },
        addon: {
          px: 0,
          borderRadius: 'base',
        },
      },
    },
    variants: {
      outline: {
        addon: {
          bgColor: 'white',
          borderRadius: 'base',
          border: 'light',
          borderColor: 'border.base',
        },
        field: {
          color: 'gray.800',
          bgColor: 'white',
          border: 'light',
          borderColor: 'border.base',
          _hover: {
            borderColor: 'secondary.tint',
          },
          _focus: {
            boxShadow: 'none',
            borderColor: 'secondary.tint',
          },
          _invalid: {
            boxShadow: 'none',
            borderColor: 'error',
          },
          _placeholder: {
            color: 'gray.700',
          },
        },
      },
      secondary: {
        addon: {
          bgColor: 'white',
          borderRadius: 'base',
          border: 'light',
          borderColor: 'border.base',
        },
        field: {
          color: 'gray.800',
          fontFamily: "'Poppins', sans-serifs",
          bgColor: 'white',
          height: '3rem',
          textAlign: 'center',
          fontSize: 'md',
          border: 'light',
          borderColor: 'border.base',
          _hover: {
            borderColor: 'secondary.base',
          },
          _focus: {
            boxShadow: 'none',
            borderColor: 'secondary.tint',
          },
          _invalid: {
            boxShadow: 'none',
            borderColor: 'error',
          },
          _placeholder: {
            color: 'gray.700',
          },
        },
      },
    },
    defaultProps: {
      size: 'sm',
    },
  },
};
